export default __webpack_public_path__ + "06c892d66fa7c05c0978747771196687.svg";